import { Injector } from '@angular/core';

export class ServiceLocator {
  public static injector: Injector;
}
